import { mediaUrls } from 'globalconfig/constants/mediaUrls';

const leftMenu = [
  {
    icon: mediaUrls.logs,
    label: 'leftMenu.logs',
    roles: ['FLMANAGER', 'DRIVER'],
    path: '/logs/list'
  },
  {
    icon: mediaUrls.user,
    label: 'leftMenu.users',
    roles: ['FLMANAGER'],
    path: '/user/list'
  },
  {
    icon: mediaUrls.vehicle,
    label: 'leftMenu.vehicles',
    roles: ['FLMANAGER'],
    path: '/vehicle/list'
  },
  {
    icon: mediaUrls.accident,
    label: 'leftMenu.accidents',
    roles: ['FLMANAGER'],
    path: '/accidents/list'
  },
  {
    icon: mediaUrls.repair,
    label: 'leftMenu.repairMaintenance',
    roles: ['FLMANAGER'],
    path: '/test'
  },
  {
    icon: mediaUrls.inspections,
    label: 'leftMenu.inspections',
    roles: ['FLMANAGER'],
    path: '/test'
  },
  {
    icon: mediaUrls.filter,
    label: 'leftMenu.filters',
    roles: ['FLMANAGER'],
    isFilter: true
  },
  {
    icon: mediaUrls.company,
    label: 'leftMenu.companyData',
    roles: ['FLEETMG'],
    path: '/test'
  },
  {
    icon: mediaUrls.usdot,
    label: 'leftMenu.USDOT',
    roles: ['FLEETMG'],
    path: '/test'
  },
  {
    icon: mediaUrls.dotAuditIcon,
    label: 'leftMenu.DOTAudit',
    roles: ['FLMANAGER'],
    path: '/logs/fmcsaLogs'
  },
  {
    icon: mediaUrls.policy,
    label: 'leftMenu.policiesProcedures',
    roles: ['FLMANAGER'],
    path: '/test'
  },
  {
    icon: mediaUrls.document,
    label: 'leftMenu.documents',
    roles: ['FLMANAGER'],
    path: '/company/document/edit'
  },
  {
    icon: mediaUrls.dailyDocuments,
    label: 'leftMenu.dailyDocuments',
    roles: ['FLMANAGER'],
    path: '/dailyDocuments/list'
  },
  {
    icon: mediaUrls.departments,
    label: 'common.departments',
    roles: ['FLMANAGER'],
    path: '/department/list/default'
  },
  {
    icon: mediaUrls.fuel,
    label: 'leftMenu.fuelReport',
    roles: ['FLMANAGER'],
    path: '/test'
  },
  {
    icon: mediaUrls.ifta,
    label: 'leftMenu.IFTAReport',
    roles: ['FLMANAGER'],
    path: '/test'
  },
  {
    icon: mediaUrls.reports,
    label: 'leftMenu.reports',
    roles: ['FLMANAGER'],
    module: 'reportsEnabled',
    path: '/report'
  },
  {
    icon: mediaUrls.developer,
    label: 'leftMenu.developerRequests',
    roles: ['FLMANAGER'],
    path: '/alerts/requests'
  },
  {
    icon: mediaUrls.feedback,
    label: 'leftMenu.feedback',
    roles: ['FLMANAGER'],
    path: '/feedback'
  }
];
export default leftMenu;
